import React from 'react';

import BASKET_UPDATE_TYPES from '@routes/Basket/components/BasketUpdateTypes';
import rewriteHttp from '@utils/rewriteHttp';
import { BasketItem } from '@common/components/BasketItem';
import { Routes } from '@common/constants';
import { Room as RoomType } from 'shared-types/Room';
import { PricePerNight } from '@common/components';
import { RoomMetadata } from './RoomMetadata';
import { RoomDetails } from './RoomDetails';
import { some } from '@utils/some';

export type RoomProps = {
  onChange: (
    type: BASKET_UPDATE_TYPES.QUANTITY | BASKET_UPDATE_TYPES.REMOVE,
    itemId: number | string,
    quantity?: number
  ) => void;
  item: RoomType;
  isEditable: boolean;
  hidePrice?: boolean;
};

export const Room: React.FC<RoomProps> = ({
  onChange,
  item: {
    bookable: {
      name,
      rate,
      imageUrl,
      ids: { roomId },
      roomExtras,
      price: roomTotalPrice,
    },
    discount,
    checkIn,
    checkOut,
    children,
    adults,
    id,
    price,
  },
  isEditable,
  hidePrice,
}) => {
  const linkParams = {
    id: roomId,
    checkIn: checkIn.split('T')[0],
    checkOut: checkOut.split('T')[0],
    adults,
    children,
  };

  function handleRoomRemoval() {
    onChange(BASKET_UPDATE_TYPES.REMOVE, id);
  }

  function renderRoomMetadata() {
    return (
      <RoomMetadata
        numberOfChildren={children}
        numberOfAdults={adults}
        checkIn={checkIn}
        checkOut={checkOut}
        rate={rate}
        roomTotalPrice={roomTotalPrice}
      />
    );
  }

  return (
    <BasketItem
      isEditable={isEditable}
      key={id}
      linkParams={linkParams}
      linkRoute={Routes.ROOM_DETAIL}
      name={name}
      discount={discount}
      onRemove={handleRoomRemoval}
      price={discount?.standardPrice || price}
      renderMetadata={renderRoomMetadata}
      renderDetails={some(roomExtras) ? <RoomDetails roomExtras={roomExtras || []} /> : undefined}
      thumbnail={rewriteHttp(imageUrl)}
      pricePerNight={
        <PricePerNight checkIn={checkIn} checkOut={checkOut} roomTotalPrice={roomTotalPrice} />
      }
      hidePrice={hidePrice}
    />
  );
};
